import React from 'react'
import Pagination from '@cloudscape-design/components-themed/pagination'

// https://cloudscape.design/components/pagination
export function RadPagination ({ ...rest }) {
  return (
    <Pagination {...rest} />
  )
}
